import * as Sentry from '@sentry/browser'

import BaseWrapper from '@olxbr/accounts-react-components/web/util/sentry'

const RELEASE = require('../../package.json').version

class Wrapper extends BaseWrapper {
  static initialize(dsn) {
    Sentry.init({
      dsn,
      release: RELEASE,
      environment: process.env.OLX_ENV || 'development',
    })
    BaseWrapper.initialize(Sentry)
  }
}

export default Wrapper
